module.exports = __webpack_public_path__ + "static/media/idun6.ebf1d5ff.JPG";